<template>
  <div style="position: relative;">
    <div class="blueCtn">
      <div class="content">
         <div class="blueText1">为您量身定制</div>        
         <div class="blueText2">卫星影像解决方案</div>        
         <div class="bluebtn"  @click="$router.push('/onlineService/Home')">购买咨询</div>  
      </div>
    </div>
    <div class="whiteCtn">
      <div class="content" style="height: 414px;">
        <div class="whiteText">
          <div class="whiteText1">产品服务</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/store','/store/rskit')">购买卫星影像</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/rskit','/store/rskit')">在线地图访问</div>
          <!-- <div class="whiteText2" @click="jumpWithPermission('可游客','/rskit','/store/rskit')">遥感专题产品</div> -->
          <div class="whiteText2" @click="jumpWithPermission('仅登录','/lab','/store/rskit')">实验室</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/openPlatform/home','/store/rskit')">星创工坊</div>
          <!-- <div class="whiteText2" @click="jumpWithPermission('可游客','/openPlatform/home','/store/rskit')">解译生产工具</div> -->
        </div>
        <div class="whiteText" style="left: 136px;">
          <div class="whiteText1">生态中心</div>
          <!-- <div class="whiteText2" @click="jumpWithPermission('可游客','/store','/store/rskit')">星林社区</div> -->
          <div class="whiteText2" @click="jumpWithPermission('仅登录','/learn','/store/rskit')">开放学堂</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/contest','/store/rskit')">创新大赛</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/jl1release','/store/rskit')">一号发布</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/popular','/store/rskit')">科普基地</div>
        </div>
        <div class="whiteText" style="left: 272px;">
          <div class="whiteText1">资源共享</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/edu','/store/rskit')">教育专区</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/resrepo','/store/rskit')">资源库</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/store/VIPBenefits','/store/rskit')">价格与认证</div>
        </div>
        <div class="whiteText" style="left: 408px;">
          <div class="whiteText1">开发者服务</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/openPlatform/APIDoc','/store/rskit')">API接口服务</div>
          <div class="whiteText2" @click="jumpWithPermission('可游客','/openPlatform/SdkIntroduction','/store/rskit')">SDK空间工具</div>
        </div>
        <div class="whiteText" style="left: 558px;">
          <div class="whiteText1">安全与合规</div>
          <div class="whiteText2" @click="goServiceAgreement">服务协议</div>
          <div class="whiteText2" @click="goPrivacyPolicy">隐私政策</div>
        </div>
        <div class="whiteText3">关注公众号</div>
        <div class="whiteText3" style="right: 12px;width: 56px;">下载APP</div>
        <img src="../assets/homefooter/关注公众号.png" alt="" class="whiteImg1">
        <img src="../assets/homefooter/下载app.png" alt="" class="whiteImg1" style="right: 0;">
        <div class="whiteLine"></div>
        <div class="whiteText4">
          © 2023-2026 长光卫星技术股份有限公司 &nbsp;版权所有&nbsp; | &nbsp;
          <span class="whiteText4Link" @click="goServiceAgreement">服务协议</span>
          &nbsp; | &nbsp;
          <span class="whiteText4Link" @click="goPrivacyPolicy">隐私政策</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rootUrl } from "@/globalConfig";
export default {
  name: "HomeFooter",
  data() {
    return {};
  },
  methods: {
    goJl1mall() {
      window.open("https://jl1mall.com", "_self"); //打开一个新的标签页
    },
    goPrivacyPolicy() {
      window.open("https://jl1mall.com/PrivacyPolicy", "_self");
    },
    goServiceAgreement() {
      window.open("https://jl1mall.com/ServiceAgreement", "_self");
    },
    //带权限判断的跳转
    jumpWithPermission(type, path, fromUrl) {
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId = localStorage.getItem("userId"); //是否已登录
      let authentication = localStorage.getItem("authentication"); //0:已实名；1：未实名
      if (type == "可游客") {
        if (fromUrl) {
          window.open(
            rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
            "_self"
          );
        } else {
          window.open(rootUrl + path, "_self");
        }
      } else if (type == "仅登录") {
        //已登录
        if (loginUserId) {
          if (fromUrl) {
            window.open(
              rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
              "_self"
            );
          } else {
            window.open(rootUrl + path, "_self");
          }
        }
        //未登录
        else {
          if (fromUrl) {
            window.open(
              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
              "_self"
            );
          } else {
            window.open(rootUrl + "/Login", "_self");
          }
        }
      } else if (type == "仅实名") {
        //已登录
        if (loginUserId) {
          //已实名
          if (authentication == "0") {
            if (fromUrl) {
              window.open(
                rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                "_self"
              );
            } else {
              window.open(rootUrl + path, "_self");
            }
          }
          //未实名
          else {
            window.open(rootUrl + "/Authentication", "_self");
          }
        }
        //未登录
        else {
          if (fromUrl) {
            window.open(
              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
              "_self"
            );
          } else {
            window.open(rootUrl + "/Login", "_self");
          }
        }
      }
    },
  },

  mounted() {},
};
</script>

<style scoped>
.blueCtn{
  position: relative;
  width: 100vw;
  height: 296px;
  background-image: url('../assets/homefooter/图2.png');
  background-position: center;
  background-size: cover;
}
.content{
  position: absolute;
  width: 1176px;
  height: 296px;
  top: 0;
  left: calc(50% - 588px);
}
.blueText1{
  position: absolute;
  top: 64px;
  left: 0;
  width: auto;
  height: 38px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 30px;
  color: rgba(0,0,0,0.85);
  line-height: 38px;
}
.blueText2{
  position: absolute;
  top: 126px;
  width: auto;
  height: 38px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 30px;
  color: rgba(0,0,0,0.85);
  line-height: 38px;
}
.bluebtn{
  position: absolute;
  top: 204px;
  width: 176px;
  height: 52px;
  background: #1890FF;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
}

.whiteCtn{
  position: relative;
  width: 100vw;
  height: 414px;
  background: #FFFFFF;
}
.whiteText{
  position: absolute;
  top: 0;
  left: 0;
  width: 130px;
  height: 326px;
  padding-top: 40px;
}
.whiteText1{
  margin-bottom: 24px;
  width:auto;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0,0,0,0.85);
  line-height: 22px;
}
.whiteText2{
  margin-bottom: 16px;
  width:auto;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 12px;
  color: rgba(0,0,0,0.65);
  line-height: 20px;
  cursor: pointer;
}
.whiteText3{
  position: absolute;
  top: 40px;
  right: 125px;
  width: 70px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0,0,0,0.85);
  line-height: 22px;
}
.whiteImg1{
  position: absolute;
  top: 86px;
  right: 120px;
  width: 80px;
  height: 80px;
}
.whiteLine{
  position: absolute;
  bottom: 167px;
  width: 1176px;
  height: 1px;
  border: 1px solid #F0F0F0;
}
.whiteText4{
  position: absolute;
  top: 327px;
  width:100%;
  height: 17px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 12px;
  color: rgba(0,0,0,0.65);
  line-height: 17px;
  text-align: center;
}
.whiteText4Link{
  cursor: pointer;
}
</style>
